import { render, staticRenderFns } from "./file_uploader.vue?vue&type=template&id=4a56fab4&scoped=true&"
import script from "./file_uploader.vue?vue&type=script&lang=js&"
export * from "./file_uploader.vue?vue&type=script&lang=js&"
import style0 from "./file_uploader.vue?vue&type=style&index=0&id=4a56fab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56fab4",
  null
  
)

export default component.exports